import { useEffect, useRef, useState } from "react";
import { default as InputCurrency } from "react-currency-input-field";
import classNames from "classnames";

interface CurrencyInputProps {
  id: string;
  name: string;
  placeholder: string;
  value?: string;
  prefix?: string;
  defaultValue?: string;
  decimalsLimit?: number;
  fixedDecimalLength?: number;
  step?: number;
  allowDecimals?: boolean;
  className?: string;
  maxLength?: number;
  disabled?: boolean;
  onValueChange: (value: string) => void;
  onFocus?: () => void;
}

const CurrencyInput = ({
  id,
  name,
  placeholder,
  value,
  prefix,
  defaultValue,
  decimalsLimit,
  fixedDecimalLength,
  step = 1,
  allowDecimals = true,
  className = undefined,
  maxLength,
  disabled = false,
  onValueChange,
  onFocus,
}: CurrencyInputProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [internalValue, setInternalValue] = useState("");

  useEffect(() => {
    setInternalValue(value || "");
    if ((!value || value === "0.00" || value === "") && inputRef.current) {
      inputRef.current.value = "";
    }
  }, [value]);

  return (
    <InputCurrency
      id={id}
      ref={inputRef}
      type="text"
      name={name}
      placeholder={placeholder}
      prefix={prefix}
      defaultValue={defaultValue}
      decimalsLimit={decimalsLimit}
      fixedDecimalLength={fixedDecimalLength}
      step={step}
      value={internalValue}
      allowNegativeValue={false}
      allowDecimals={allowDecimals}
      disableAbbreviations
      decimalScale={2}
      disabled={disabled}
      intlConfig={{
        locale: navigator.language === "es" ? "es-ES" : "en-US",
        currency: "",
      }}
      maxLength={maxLength}
      className={classNames(
        "border-0 font-semibold !px-0 text-xl min-w-36",
        className
      )}
      onValueChange={(v: string | undefined) => {
        if (Number(value) !== Number(v)) onValueChange(v || "");
        setInternalValue(v || "");
      }}
      onFocus={() => {
        if (
          inputRef.current &&
          (inputRef.current.value === "$0.00" ||
            inputRef.current.value === "0.00")
        ) {
          inputRef.current.value = "";
          setInternalValue("");
        }
        onFocus?.();
      }}
    />
  );
};

export default CurrencyInput;
